<template>
	<div class="content text-white">
		<div class="text-3.5xl mb-3">Foto Selfi dengan Nomor Acak</div>
		<div class="text-xs mb-8">
			<Breadcrumbs />
		</div>

		<div class="grid grid-cols-70-30 gap-12">
			<div>
				<div class="card  rounded-b-none p-5 mb-0.5">
					<Banner :type="`${error ? 'warning' : undefined}`" class="mb-5">
						<div class="flex items-center gap-3">
							<div>
								<IconInfo :color_prop="bannerIconColor" />
							</div>

							<div v-if="error">
								<div class="text-sm font-medium mb-1">Kamera perangkat Anda tidak dapat berfungsi</div>
								<div class="text-xs">
									Jika kamera pada perangkat Anda tidak berfungsi, gunakan
									kamera eksternal atau menggunakan perangkat lain
								</div>
							</div>

							<div v-else>
								<div class="text-sm font-medium mb-1">Lakukan foto selfie dengan nomor acak berikut</div>
								<div class="text-xs">
									Jika kamera pada perangkat Anda mengalami kendala, gunakan kamera eksternal atau perangkat lain
								</div>
							</div>

							<div class="grow text-center">
								<div class="bg-white text-black font-bold p-3">
									{{ $store.state.bankAccount.validationString }}
								</div>
							</div>
						</div>
					</Banner>

					<div class="flex justify-center items-center">
						<!-- <img src="https://www.pngkit.com/png/detail/297-2978148_full-size-360-person-placeholder.png" alt=""> -->
						<!-- Camera Component -->
						<Camera ref="camera" :cameraOn="cameraOn" @camera-ready="handleCameraReady" @photo-taken="handlePhotoTaken"
							@error="handleError" />
					</div>

				</div>

				<div class="card rounded-t-none p-5">
					<div v-if="photoTaken" class="flex flex--same-width gap-2">
						<button class="btn c-btn-theme" @click="retake()">Ambil Ulang Foto</button>
						<button class="btn c-btn-theme" @click="submitPhoto()">Simpan & Lanjutkan</button>
					</div>

					<button v-else-if="cameraOn" class="btn c-btn-theme w-full" @click="capturePhoto"
						:disabled="error ? true : false">Ambil Foto dengan
						Kamera</button>

					<button v-else class="btn c-btn-theme w-full" @click="toggleCamera">Nyalakan Kamera</button>

				</div>
			</div>

			<!-- Daftar Rekening Penerima -->
			<div>
				<div class="card rounded-b-none p-5 mb-0.5">
					<div class="text-sm">Petunjuk Selfie</div>
				</div>

				<div class="card rounded-t-none p-5">
					<div class="bg-white text-center mb-5">
						<img src="@/assets/img/foto-hold-paper.png" alt="">
					</div>
					<div class="flex gap-2 text-xs mb-2">
						<div>1. </div>
						<div>Tulis nomor acak yang tertera pada sebuah kertas</div>
					</div>
					<div class="flex gap-2 text-xs mb-2">
						<div>2. </div>
						<div>Ambil foto selfie dengan memegang kertas yang sudah dituliskan nomor acak</div>
					</div>
					<div class="flex gap-2 text-xs mb-2">
						<div>3. </div>
						<div>Pastikan wajah dan kertas berisi nomor acak terlihat jelas / tidak blur</div>
					</div>
				</div>
			</div>
		</div>

		<InputOtp ref="inputOtpRef" @submit="submitOtp" @resend="resendOtpFunc" @close="handleCloseOtp"
			titleDefault="Kode OTP Via Email" textDefault="Silakan masukkan kode OTP yang kami kirimkan melalui email Anda"
			:contactDefault="$store.getters.getEmailCencored" />
	</div>
</template>

<script>
import useBankAccount from '../../composable/useBankAccount'

import Banner from '@/components/Banner.vue'
import Select from '@/components/ui/Select.vue'
import LogoAbi from '@/components/logo/LogoAbi.vue'
import Alert from '@/components/alert-component/AlertComponent.js'
import InputOtp from './components/InputOtp.vue'
import IconInfo from '../../components/icons/IconInfo.vue'
import Camera from '../../components/Camera.vue'
import Breadcrumbs from '../../components/Breadcrumbs.vue'

export default {
	name: 'TakePhoto',

	mixins: [useBankAccount],

	components: {
		Banner,
		Select,
		LogoAbi,
		InputOtp,
		IconInfo,
		Camera,
		Breadcrumbs,
	},
	data() {
		return {
			themeColor: getComputedStyle(document.documentElement).getPropertyValue('--color-theme'),
			colorWarning: getComputedStyle(document.documentElement).getPropertyValue('--color-warning'),

			cameraOn: false, // Toggle camera state
			error: null, // Error message
			photo: null, // Captured photo
			photoTaken: false,

			timer: null,
		}
	},

	computed: {
		bannerIconColor() {
			return this.error ? this.colorWarning : this.themeColor
		},
	},

	mounted() {
		this.timer = this.$refs.inputOtpRef.startTimer(60)

		if (this.$store.state.bankAccount.whichProcessAddBankAccount === 'otp') {
			this.openInputOtp()
		}
	},

	methods: {
		open() {
			Alert.open({
				type: 'success',
				title: 'Persetujuan Pengguna',
				description: 'Saya setuju untuk data terkait dengan nomor rekening yang saya masukkan untuk diverifikasi lebih lanjut oleh JFXGOLD X',
			})
		},

		toggleCamera() {
			this.cameraOn = !this.cameraOn
		},
		handleCameraReady(isReady) {
			if (isReady) {
				this.error = null // Clear any existing errors
				console.log("Camera is ready.")
			}
		},
		capturePhoto() {
			this.$refs.camera.capturePhoto()
			this.syncPhotoTaken()
			this.toggleCamera()
		},
		handlePhotoTaken(photoData, photoBlob) {
			this.photo = photoBlob
		},
		handleError(err) {
			this.error = err.message || "An error occurred."
		},

		syncPhotoTaken() {
			this.photoTaken = this.$refs.camera.photoTaken
		},
		retake() {
			this.$refs.camera.setPhotoTaken(false)
			this.syncPhotoTaken()
			this.toggleCamera()
		},

		async submitPhoto() {
			try {
				// Submit the photo to the server
				await this.addImageVerification({
					image: this.photo,
				})

				// change which process addBankAccount to 'otp'
				this.$store.commit('bankAccount/setWhichProcessAddBankAccount', 'otp')

				// Open the OTP input modal
				this.openInputOtp()
			} catch (err) {

			}
		},

		restartTimer() {
			this.timer.complete()
			this.timer.reset(60)
			this.timer.start()
		},

		setInputOtp() {
			let title, text, contact, mode

			if (this.$store.state.bankAccount.otpModeAddBankAccount === 'email') {
				title = 'Kode OTP Via Email'
				text = 'Silakan masukkan kode OTP yang kami kirimkan melalui email Anda'
				contact = this.$store.getters.getEmailCencored
				mode = 'email'
			} else {
				title = 'Kode OTP Via SMS'
				text = 'Silakan masukkan kode OTP yang kami kirimkan melalui SMS Anda'
				contact = this.$store.getters.getPhoneNumberCensored
				mode = 'sms'
			}

			this.$refs.inputOtpRef.setTitle(title)
			this.$refs.inputOtpRef.setText(text)
			this.$refs.inputOtpRef.setContact(contact)
			this.$refs.inputOtpRef.setMode(mode)
			this.$refs.inputOtpRef.clearOtp()
		},

		openInputOtp() {
			// setting up input otp modal
			this.setInputOtp()

			// Open the OTP input modal
			this.$refs.inputOtpRef.openInputOtp()
			this.timer.start()
		},

		/**
		 * Submit the OTP to the server
		 * @param {String} otp The OTP
		 */
		async submitOtp(otp) {
			const payload = {
				otp: otp,
			}

			try {
				// Validate the OTP
				if (this.$store.state.bankAccount.otpModeAddBankAccount === 'email') {
					await this.validateOtpEmail(payload)

					this.$store.state.bankAccount.otpModeAddBankAccount = 'sms'

					// restart timer
					this.restartTimer()

					// set input otp modal to SMS mode
					this.setInputOtp()
				} else {
					await this.validateOtpSms(payload)

					this.$refs.inputOtpRef.closeInputOtp()
					this.$router.push({ name: 'Withdrawal' })
				}
			} catch (err) {
				console.log('ERROR TIMER', err, this.timer)
				if (err == 'stopTimer') {
					this.timer.complete()
				}
			}
		},

		async resendOtpFunc() {
			try {
				await this.resendOtp('addBankAccount')
				
				// restart timer
				this.restartTimer()
			} catch (err) {

			}
		},

		handleCloseOtp() {
			this.$router.push({ name: 'Add Bank Account' })
		},
	},

	beforeRouteLeave(to, from, next) {
		if (!this.$store.state.bankAccount.requestKeyAddBankAccount) {
			next()
			return
		}

		// if to login then proceed
		if (to.name === 'Login') {
			this.$store.dispatch('bankAccount/removeAddBankAccountLocalStorage')
			next()
			return
		}

		Alert.open({
			type: 'confirm',
			title: 'Apakah Anda Yakin ingin Keluar?',
			description: 'Jika Anda keluar, proses penambahan rekening akan dibatalkan (tidak dapat disimpan)',
			onConfirm: () => {
				this.$store.dispatch('bankAccount/removeAddBankAccountLocalStorage')
				next()
			},
			onDecline: () => {
				next(false)
			}
		})
	},
}
</script>

<style scoped>
.norek {
	margin-bottom: 0.125rem;
}

.card {
	background-color: var(--grey-4-color);
}

.logo-bagi {
	width: 1.5em;
	height: 1.5em;
}
</style>
